export default {
    getFields(Selector) {
        return {
            "user_email": {
                required: true,
                email: true,
                remote: {
                    url: "/pl/api/v1/register/check_email/",
                    type: "post",
                    data: {}
                }
            },
            "first_name": {
                required: true
            },
            "last_name": {
                required: true
            },
            "userPassword": {
                required: true,
                userPassword: true
            },
            "userPasswordConfirm": {
                required: true,
                equalTo: "#userPassword"
            }
        }
    }
}export default {
    getFields(Selector) {
        return {
            "user_email": {
                required: true,
                email: true,
                remote: {
                    url: "/pl/api/v1/register/check_email/",
                    type: "post",
                    data: {}
                }
            },
            "first_name": {
                required: true
            },
            "last_name": {
                required: true
            },
            "userPassword": {
                required: true,
                userPassword: true
            },
            "userPasswordConfirm": {
                required: true,
                equalTo: "#userPassword"
            }
        }
    }
}